import { ModalHandler } from '@app-velocity/ui';

import { NewPluginUIVersionModalContent } from './components/NewPluginUIVersionModalContent';

export const NewPluginUIVersionModal = () => {
  return (
    <ModalHandler channel="system" id="new-plugin-ui-version">
      <NewPluginUIVersionModalContent />
    </ModalHandler>
  );
};
